
import Config from "../config";
import {FieldMetadataModel,
        FieldMetadataJSON,
        FieldMetadataFactory,
        ListViewModel,
        ListViewJSON,
        ListViewFactory,
        ListViewFilterModel,
        ListViewFilterFactory,
        ViaElementFilterModel,
        ViaElementFilterJSON,
        ViaElementFilterFactory} from '../models/models';

/*
import {formatDate} from "../utils/dateFunctions.js";
import {getIndustryFromVerticalBundle} from "../utils/mapFunctions.js";
*/


export const fetchFields = async (authToken: string, objectApiName: string): Promise<FieldMetadataModel[]> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/mdt/r/fields/${objectApiName}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.fields ||
         !Array.isArray(data.fields)){
          throw new Error("Unhandled error")
      }

      const fieldFactory = new FieldMetadataFactory()
      const fields = data.fields.map((thisJSON: any) => fieldFactory.fromJSON(thisJSON));

      return fields

    } catch (error){
      throw new Error(`Error when fetching fields: ${(error as Error).message}`)
    }
}

export const fetchViaElements = async (authToken: string, objectApiName: string): Promise<ViaElementFilterModel> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/mdt/r/viaelements/${objectApiName}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();


      if(!data ||
         !data.via_element){
          throw new Error("Unhandled error")
      }

      const viaElement = new ViaElementFilterFactory().fromJSON(data.via_element)

      return viaElement

    } catch (error){
      throw new Error(`Error when fetching fields: ${(error as Error).message}`)
    }
}


export const initListViewFilter = async (authToken: string, listviewUuid: string): Promise<ListViewFilterModel> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/mdt/i/listviewfilter/${listviewUuid}`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.listviewfilter){
          throw new Error("Unhandled error")
      }

      const listviewfilter = new ListViewFilterFactory().fromJSON(data.listviewfilter);

      return listviewfilter

    } catch (error){
      throw new Error(`Error when initializing listview filter: ${(error as Error).message}`)
    }
}



export const upsertListView = async (authToken: string, objectApiName: string, listView: ListViewModel): Promise<ListViewModel> => {

    try {

      //get object information for the selected lookup
      let url = `${Config.getInstance().getCoordinationServiceURL()}/api/mdt/cu/${objectApiName}/listview`;
      const headers = new Headers();

      headers.append("Authorization", `Bearer ${authToken}`);
      headers.append("Accept", "application/json");
      headers.append("Content-Type", "application/json");

      const listViewJSON = new ListViewFactory().toJSON(listView);

      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: JSON.stringify({"listview": listViewJSON})
      });

      if(!response.ok) {
        const errorData = await response.json();
        if(!errorData.message){
          throw new Error("Unhandled error")
        } else{
          throw new Error(errorData.message);
        }
      }

      const data = await response.json();

      if(!data ||
         !data.listview){
          throw new Error("Unhandled error")
      }

      const listview = new ListViewFactory().fromJSON(data.listview);

      return listview

    } catch (error){
      throw new Error(`Error when upserting listview: ${(error as Error).message}`)
    }
}
